// Slow editorial marquee strip
export const Marquee = ({ text, dark = false, testid }) => {
  const item = (
    <span className="flex items-center whitespace-nowrap">
      {[0, 1, 2, 3].map((i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-5xl lg:text-6xl px-8 tracking-tight">{text}</span>
          <span className="font-serif text-3xl md:text-5xl lg:text-6xl opacity-40">/</span>
        </span>
      ))}
    </span>
  );
  return (
    <div
      data-testid={testid}
      className={`overflow-hidden py-10 md:py-14 border-y ${dark ? "bg-bottle-green text-cream border-cream/15" : "bg-warm-beige text-bottle-green border-dark-text/10"}`}
    >
      <div className="flex w-max animate-marquee">
        {item}
        {item}
      </div>
    </div>
  );
};
